// extracted by mini-css-extract-plugin
module.exports = {"postCodeSearchResultBuilding":"post-code-selector_postCodeSearchResultBuilding__3VRF3"};